import React from 'react';
import { Star, CheckCircle, MapPin } from 'lucide-react';
import { MOCK_TESTIMONIALS } from '../../mock';
import { Link } from 'react-router-dom';

const TestimonialsPage: React.FC = () => (
  <div>
    <div className="page-header" style={{ paddingTop: '7rem' }}>
      <div style={{ display: 'flex', gap: '0.25rem', justifyContent: 'center', marginBottom: '1rem' }}>
        {[1,2,3,4,5].map(i => <Star key={i} size={24} fill="#f97316" stroke="none" />)}
      </div>
      <h1 style={{ color: 'white', fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 800, marginBottom: '1rem' }}>Customer Reviews</h1>
      <p style={{ color: '#94a3b8', fontSize: '1rem' }}>4.9/5 average from 500+ verified reviews across Google, Yelp, and Facebook.</p>
    </div>

    <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container-xl">
        {/* Rating Summary */}
        <div className="card" style={{ marginBottom: '3rem', display: 'flex', flexWrap: 'wrap', gap: '2rem', justifyContent: 'center', padding: '2rem', textAlign: 'center' }}>
          {[
            { label: 'Google', rating: '4.9', count: '312 reviews' },
            { label: 'Yelp', rating: '4.8', count: '128 reviews' },
            { label: 'Facebook', rating: '4.9', count: '97 reviews' },
            { label: 'HomeAdvisor', rating: '4.7', count: '64 reviews' },
          ].map(p => (
            <div key={p.label}>
              <div style={{ fontSize: '2rem', fontWeight: 900, color: '#f97316' }}>{p.rating}</div>
              <div style={{ display: 'flex', gap: '2px', justifyContent: 'center', margin: '0.25rem 0' }}>
                {[1,2,3,4,5].map(i => <Star key={i} size={14} fill="#f97316" stroke="none" />)}
              </div>
              <div style={{ fontWeight: 700, color: 'var(--text-primary)', fontSize: '0.9rem' }}>{p.label}</div>
              <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>{p.count}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '1.5rem' }}>
          {MOCK_TESTIMONIALS.map(t => (
            <div key={t.id} className="card card-hover">
              <div style={{ display: 'flex', gap: '0.375rem', marginBottom: '1rem' }}>
                {Array.from({ length: t.rating }).map((_, i) => <Star key={i} size={16} fill="#f97316" stroke="none" />)}
              </div>
              <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: '1.25rem', fontStyle: 'italic', fontSize: '0.9rem' }}>"{t.text}"</p>
              <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                {t.avatar && <img src={t.avatar} alt={t.name} style={{ width: '2.5rem', height: '2.5rem', borderRadius: '50%', objectFit: 'cover' }} />}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.875rem', color: 'var(--text-primary)' }}>{t.name}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                    <MapPin size={11} /> {t.location}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '0.75rem', color: '#f97316', fontWeight: 600 }}>{t.service}</div>
                  {t.verified && <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.7rem', color: '#10b981', marginTop: '0.2rem' }}><CheckCircle size={11} /> Verified</div>}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '3rem' }}>
          <Link to="/get-quote" className="btn-primary">Ready to Get Started?</Link>
        </div>
      </div>
    </section>
  </div>
);

export default TestimonialsPage;
